import type { ReactElement } from "react";

import { FiltersChip } from "../FiltersChip/FiltersChip";

import { StyledChipsContainer, StyledChipsDivider, StyledChipsWrapper } from "./styles";

export type ChipGroupItem<T = string> = {
    name: string;
    type: T;
};

type ChipsGroupProps<T = string> = {
    chipItems: ChipGroupItem<T>[];
    onDelete: (item: ChipGroupItem<T>) => void;
    divider?: string;
};

const ChipsGroup = <T extends string>({ chipItems, divider, onDelete }: ChipsGroupProps<T>): ReactElement => {
    return (
        <StyledChipsContainer>
            {chipItems.map((chip: ChipGroupItem<T>, i: number) => {
                return (
                    <StyledChipsWrapper key={i}>
                        {i > 0 ? <StyledChipsDivider>{divider}</StyledChipsDivider> : null}
                        <FiltersChip
                            text={chip.name}
                            onClose={() => onDelete(chip)}
                        />
                    </StyledChipsWrapper>
                );
            })}
        </StyledChipsContainer>
    );
};

export default ChipsGroup;
